"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
function MultiSelectAutocomplete({ options, name, value, id, disabled, error, label, getOptionLabel, isOptionEqualToValue, required, inputValue, onChange, onChangeInput, helperText, }) {
    return (react_1.default.createElement(Autocomplete_1.default, { multiple: true, limitTags: 2, id: id, value: value, onInputChange: onChangeInput, onChange: onChange, options: options, isOptionEqualToValue: isOptionEqualToValue, getOptionLabel: getOptionLabel, renderInput: (params) => (react_1.default.createElement(TextField_1.default, { ...params, InputLabelProps: {
                shrink: false,
                focused: false,
            }, name: name, required: required, disabled: disabled, error: error, helperText: helperText, label: label, value: inputValue })) }));
}
exports.default = MultiSelectAutocomplete;
